import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";

export enum LazoUserSessionEvents {
  LOGIN = "LOGIN",
}

class LazoUserSessionService {
  path: string;
  constructor(path: string) {
    this.path = path;
  }

  async register(body: { sessionEvent: LazoUserSessionEvents; userExternalId: string }): Promise<void> {
    HttpClientV2.post(this.path, body);
  }
}

export default new LazoUserSessionService("/api/lazo-user-visit-session");
